export default class IndicatorsCtrl {
  constructor ($scope, $timeout, $stateParams, WorkPlanSrv, GlobalConfig, WorkPlanIndicatorSrv, $cookies, $rootScope, $interval) {
  
    const indicatorsVm = this
    const teacher = {
      teacherId : JSON.parse($cookies.get('currentUser')).teacherId
    }

  //declaracion de variables
    $rootScope.addchargesAssigned = false
    indicatorsVm.type = $stateParams.indicatorType

  //variables para indicadores de tipo docencia
    indicatorsVm.percentage          = 0
    indicatorsVm.asignaturesAssigned = 0
    indicatorsVm.totalAsignatures    = 0
    indicatorsVm.otherActivities     = 0
    indicatorsVm.hours               = 0

  //variables indicadores para gestión academica
    indicatorsVm.chargesAssigned = 0
    indicatorsVm.totalCharges    = 0
    indicatorsVm.roles           = 0
    indicatorsVm.committee       = 0

  //variables indicadores para consolidacion CP
    indicatorsVm.percentage  = 0
    indicatorsVm.phd         = 0
    indicatorsVm.courses     = 0
    indicatorsVm.communities = 0

  //variables indicadores para investigacion
    indicatorsVm.pagination          = 1
    indicatorsVm.projectsFormulated  = 0
    indicatorsVm.projects            = 0
    indicatorsVm.products            = 0       
    indicatorsVm.spacesCollaboration = 0  
    indicatorsVm.researchTraining    = 0 
    indicatorsVm.transferResults     = 0 
  
  //variables indicadores para extension
    indicatorsVm.projectsExtension   = 0
    indicatorsVm.visibility          = 0  
    indicatorsVm.adviceConsultancy   = 0  
    indicatorsVm.shortCourses        = 0

  //Función temporal para sumar al agregar cargo por delegación
    let getChargesAssigned = $interval(function () {

      if($rootScope.addchargesAssigned)
        {
          indicatorsVm.chargesAssigned += 1
          $rootScope.addchargesAssigned = false
        }

        indicatorsVm.totalAsignatures = $rootScope.totalAsignatures ? $rootScope.totalAsignatures : 0

    }, 500)


  // declaracion de variable global y variable compartida para 
  // actualizar la vista en caso de recibir un aviso
    indicatorsVm.globalConfig   = GlobalConfig.indicatorsType
    indicatorsVm.sharedVariable = WorkPlanIndicatorSrv.getVariable()   

    indicatorsVm.sharedVariable.reload = function () {
      indicatorsVm.sharedVariable = WorkPlanIndicatorSrv.getVariable()
      let recargarIndicador = indicatorsVm.sharedVariable.pop()
      if (recargarIndicador){
        activate()
        WorkPlanIndicatorSrv.setVariable(false)
      }
    }

  //declaracion de funciones
    activate()

    function activate(){
      $timeout(function () {
        getIndicators()
      }, 10000)              

    }


    // When the teacher has no planned activities in the requested submodule,
    // _getProgressBySubmodule returns a row with submoduleId = NULL; findIndex
    // returns -1 and dereferencing [-1].percentage crashes. Keep percentage at
    // its default 0 in that case so the empty ring still renders.
    function loadIndicatorsTeaching(datos){

      if(datos !== []){
        var index = datos.asignaturesPlaned.findIndex(function(item, i){
          return item.submoduleId === indicatorsVm.globalConfig.teaching
        })
        if (index >= 0) {
          indicatorsVm.percentage        = datos.asignaturesPlaned[index].percentage
        }
        indicatorsVm.asignaturesAssigned = datos.asignaturesAssigned[0].asignaturesAssigned
        //indicatorsVm.totalAsignatures    = datos.asignaturesAssigned[0].totalAsignatures
        indicatorsVm.otherActivities     = datos.otherActivities
        indicatorsVm.hours               = datos.attencionHours ? datos.attencionHours : 0
      }

    }

    function loadIndicatorsAcademicManagement(datos){
      if(datos !== []){
        var index = datos.asignaturesPlaned.findIndex(function(item, i){
          return item.submoduleId === indicatorsVm.globalConfig.academicManagement
        })
        if (index >= 0) {
          indicatorsVm.percentage    = datos.asignaturesPlaned[index].percentage
        }
        indicatorsVm.chargesAssigned = datos.delegationCharges.chargesAssigned
        indicatorsVm.totalCharges    = datos.delegationCharges.totalCharges
        indicatorsVm.otherActivities = datos.otherActivityAM
        indicatorsVm.roles           = datos.roles
        indicatorsVm.committee       = datos.committee

      }

    }

    function loadIndicatorsConsolidation(datos){
      if(datos !== []){
        var index = datos.asignaturesPlaned.findIndex(function(item, i){
          return item.submoduleId === indicatorsVm.globalConfig.consolidationCP
        })
        if (index >= 0) {
          indicatorsVm.percentage    = datos.asignaturesPlaned[index].percentage
        }
        indicatorsVm.phd             = datos.phd
        indicatorsVm.courses         = datos.courses
        indicatorsVm.communities     = datos.communities

      }
    }

    function loadIndicatorsResearch(datos){

      if(datos !== []){
        var index = datos.asignaturesPlaned.findIndex(function(item, i){
          return item.submoduleId === indicatorsVm.globalConfig.research
        })
        if (index >= 0) {
          indicatorsVm.percentage        = datos.asignaturesPlaned[index].percentage
        }
        indicatorsVm.projectsFormulated  = datos.projectsFormulated
        indicatorsVm.projects            = datos.projects
        indicatorsVm.products            = datos.products
        indicatorsVm.spacesCollaboration = datos.spacesCollaboration
        indicatorsVm.researchTraining    = datos.researchTraining
        indicatorsVm.transferResults     = datos.transferResults
      }

    }

    function loadIndicatorsExtension(datos){

      if(datos !== []){
        var index = datos.asignaturesPlaned.findIndex(function(item, i){
          return item.submoduleId === indicatorsVm.globalConfig.extension
        })
        if (index >= 0) {
          indicatorsVm.percentage       = datos.asignaturesPlaned[index].percentage
        }
        indicatorsVm.projectsFormulated = datos.projectsFormulatedExtension
        indicatorsVm.projectsExtension  = datos.projectsExtension
        indicatorsVm.visibility         = datos.visibility
        indicatorsVm.adviceConsultancy  = datos.adviceConsultancy
        indicatorsVm.shortCourses       = datos.shortCourses

      }

    }


    function getIndicators(){
      let post = {
        teacherId: teacher.teacherId,
        submoduleId: indicatorsVm.type
      }
      WorkPlanSrv.getIndicatorBySubmodule.getList(post).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          let datos = dataReturn.data  
          //indicadores de Docencia
          if (indicatorsVm.type === indicatorsVm.globalConfig.teaching){
              loadIndicatorsTeaching(datos)
          //indicadores de Gestion Académica
          } else if (indicatorsVm.type === indicatorsVm.globalConfig.academicManagement){
              loadIndicatorsAcademicManagement(datos)
          //indicadores de Consolidacion CP
          }  else if (indicatorsVm.type === indicatorsVm.globalConfig.consolidationCP){
              loadIndicatorsConsolidation(datos)
          //indicadores de Investigación
          }  else if (indicatorsVm.type === indicatorsVm.globalConfig.research){
              loadIndicatorsResearch(datos)
          //indicadores de Extension
          }  else if (indicatorsVm.type === indicatorsVm.globalConfig.extension){
              loadIndicatorsExtension(datos)
          }  
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data);
      })
    }

  }
}

IndicatorsCtrl.$inject = ['$scope', '$timeout', '$stateParams', 
                          'WorkPlanSrv', 'GlobalConfig', 
                          'WorkPlanIndicatorSrv', '$cookies', '$rootScope', '$interval']





// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/indicators/indicatorsCtrl.js